import { VStack } from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";

import { SelectControlled } from "@repo/core/components/forms/SelectControlled";
import { ReportSelectFiltersProps } from "./types";
import { useReportSelectFilters } from "./controller";

export const ReportSelectFilters = ({ onClose }: ReportSelectFiltersProps) => {
  const {
    control,
    onSubmitForm,
    availableStores,
    availableProducts,
    availableAttendants,
    isMobile,
    isFetchingFilters
  } = useReportSelectFilters({
    onClose
  });

  return (
    <VStack flex={1} overflow="hidden" height="$100vh">
      <VStack flex={1} bgColor="$white" h="$full">
        <VStack gap="$4" p="$4" pb="$6" flex={4}>
          <SelectControlled
            control={control}
            name="store"
            label="Loja"
            placeholder="Filtrar por loja"
            options={availableStores.map((store) => ({
              label: store.descrLoja,
              value: store.codigoEstabelecimento
            }))}
          />
          <SelectControlled
            control={control}
            name="product"
            label="Produto"
            placeholder="Filtrar por produto"
            options={availableProducts.map((product) => ({
              label: product.strDescricao,
              value: product.strProduto
            }))}
          />
          <SelectControlled
            control={control}
            name="attendant"
            label="Atendente"
            placeholder="Filtrar por atendente"
            options={
              availableAttendants?.map((attendant) => ({
                label: attendant.nome,
                value: attendant.atendente
              })) || []
            }
            isLoading={isFetchingFilters}
          />
        </VStack>
        <VStack
          flex={1}
          px="$4"
          flexDirection={isMobile ? "column-reverse" : "row"}
          alignItems={isMobile ? "flex-start" : "flex-end"}
          p={isMobile ? "$0" : "$4"}
          justifyContent={isMobile ? "center" : "flex-end"}
          gap="$2"
        >
          <Button
            w="$full"
            borderRadius={isMobile ? "$md" : "$lg"}
            size={isMobile ? "lg" : "sm"}
            text="Concluir"
            onPress={onSubmitForm}
          />
        </VStack>
      </VStack>
    </VStack>
  );
};
